<template>
  <div>
    <div v-for="content of displayContentTop" v-if="displayContentTop && displayContentTop.length" class="col-12 px3">
      <div v-if="!content.display_content_type" v-html="getConfigurationContent(content)"> </div>
      <DisplayContent v-else :content="content" />
    </div>
    <div v-if="!isEligible" class="m3 p3 white-bg flex my3">
      <span class="flex flex-auto h5n semi-bold justify-center">{{ getReferencelabel("NEW_REFERRAL") }}</span>
    </div>
    <div v-else>
      <div v-show="showMessage" class="m3" :class="{ 'success': success, 'danger': !success }">
        <span>{{ statusMessage }}</span>
      </div>
      <GenerateForm v-model:form="form" :data="data" clear-data="true" :save-action="saveData" button-name="SPONSOR" />
    </div>
    <div v-for="content of displayContentUnder" v-if="displayContentUnder && displayContentUnder.length" class="col-12 px4">
      <div v-if="!content.display_content_type" v-html="getConfigurationContent(content)"> </div>
      <DisplayContent v-else :content="content" />
    </div>
  </div>
</template>

<script>

import { reactive, computed, ref } from 'vue';
import { useStore } from 'vuex';
import GenerateForm from '@/components/common/GenerateForm';
import DisplayContent from '@/components/elements/DisplayContent.vue';
import { createReferral } from '@/mixins/requests';
import { getConfigurationContent, getReferencelabel, isInImpersonateModeNotification } from '@/mixins/utils';

export default {
  components: { GenerateForm, DisplayContent },
  setup () {
    const store = useStore();
    const success = ref(false);
    const statusMessage = ref('');
    const showMessage = computed(() => !!statusMessage.value);
    const form = require('@/configs/referralForm.json');
    const data = reactive({});
    const isEligible = ref(store.state.user.is_eligible_referrer);
    async function saveData () {
      if (isInImpersonateModeNotification()) {
        return;
      }

      statusMessage.value = '';
      store.commit('setLoading', true);
      const response = await createReferral(data, store.state.user.uuid);
      if (response && response.success) {
        statusMessage.value = getReferencelabel('SPONSOR_SUCCESS_INFO');
        success.value = true;
      } else {
        const exist = response && response.message && response.message.includes('exists');
        statusMessage.value = exist ? getReferencelabel('UCPA_CLIENT') : "Une erreur s'est produite lors de la création du sponsor, réessayez";
        success.value = false;
      }
      Object.assign(data, { firstname: null, lastname: null, email: null });
      store.commit('setLoading', false);
    }

    const displayContentTop = computed(() => store.getters.getSiteConfiguration('display_content', 'SPONSOR_CREATE_TOP'));
    const displayContentUnder = computed(() => store.getters.getSiteConfiguration('display_content', 'SPONSOR_CREATE_DESCRIPTION'));

    return { data, form, saveData, success, statusMessage, showMessage, isEligible, displayContentTop, displayContentUnder, getConfigurationContent, getReferencelabel };
  },
  methods: {
    forceUpdate () {
      this.$forceUpdate();
    }
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

</style>
